import React, { useState } from "react";
import "./SignUp.css";
import { Container, Form } from "react-bootstrap";
import Logo from "../Common-Component/Reset_Flow/Logo/Logo";
import Heading from "../Common-Component/Reset_Flow/Heading/Heading";
import OrangeFilledRoundBtn from "../Common-Component/Common_Btn/OrangeFilledRoundBtn/OrangeFilledRoundBtn";
import Banner from "../Common-Component/Reset_Flow/Banner/Banner";
import { Link, useNavigate } from "react-router-dom";
import BrownSuccessFullModal from "../Common-Component/Common_Modal/BrownSuccessFullModal/BrownSuccessFullModal";
import { useForm, Controller } from "react-hook-form";
import classNames from "classnames";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PasswordChecklist from "react-password-checklist";
import { LineStyle } from "@mui/icons-material";
import { RegxExpression } from "../../utils/common";
import { useDispatch } from "react-redux";
import { userSignUp } from "../../features/auth/authSlice";

export default function SignUp() {
  const navigate = useNavigate();

  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [password, setPassword] = useState("");
  const [passwordAgain, setPasswordAgain] = useState("");

  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordOne, setShowPasswordOne] = useState(false);
  const [iconOne, setIconOne] = useState(faEyeSlash);
  const [iconTwo, setIconTwo] = useState(faEyeSlash);

  const togglePasswordVisibility = (field) => {
    if (field === "password") {
      setShowPassword(!showPassword);
      setIconOne(showPassword ? faEyeSlash : faEye);
    } else if (field === "reenterPassword") {
      setShowPasswordOne(!showPasswordOne);
      setIconTwo(showPasswordOne ? faEyeSlash : faEye);
    }
  };

  const {
    control,
    register,
    handleSubmit,
    getValues,
    setValue,
    setError,
    clearErrors,
    formState: { errors },
    reset,
    trigger,
  } = useForm();
  
  const dispatch = useDispatch();
  const onSubmit = async (data) => {
    const res = await dispatch(userSignUp(data));

    if (res.meta?.requestStatus === "fulfilled") {
      setShowSuccessModal(true);
      setTimeout(() => {
        navigate("/home");
      }, 3000);
    } else if (res.meta?.requestStatus === "rejected") {
        if (res.payload?.errors?.email) {
            setError("email", {
              type: "manual",
              message: res.payload?.errors?.email,
            });
          }
    }
  };


  return (
    <section className="signup-page ">
      <Container>
        <div className="signup-card">
          <Logo />
          <Heading headingText={"SIGN UP"} />
          <p className="subtext">
            {" "}
            Create Your Account Using Your Email And Mobile Number.
          </p>
          <Form className="signup-form">
            <Form.Group className="form-group">
              <Form.Control
                type="text"
                name="name"
                placeholder="Full Name"
                {...register("name", {
                  required: "First name required",
                })}
                className={classNames("", {
                  "is-invalid": errors?.name,
                  "is-valid": getValues("name"),
                })}
              />
              {errors?.name && (
                <sup className="text-danger">{errors?.name?.message}</sup>
              )}
            </Form.Group>

            <Form.Group className="form-group">
              <Form.Control
                type="text"
                name="email"
                placeholder="Email"
                {...register("email", {
                  required: "Email is required",
                  pattern: {
                    value: RegxExpression.email,
                    message: "Invalid email ",
                  },
                })}
                className={classNames("", {
                  "is-invalid": errors?.email,
                  "is-valid": getValues("email"),
                })}
              />
              {errors?.email && (
                <sup className="text-danger">{errors?.email?.message}</sup>
              )}
            </Form.Group>

            <Form.Group className="form-group">
              <Controller
                name="contact_no"
                control={control}
                rules={{
                  required: "Contact number is required",
                  minLength: {
                    value: 10,
                    message: "Number should be at least 10 characters",
                  },
                }}
                render={({ field }) => (
                  <Form.Control
                    {...field}
                    className={classNames("", {
                      "is-invalid": errors?.contact_no,
                      "is-valid": getValues("contact_no"),
                    })}
                    // onChange={(value) => field.onChange(value)}
                    type="text"
                    placeholder="Mobile Number"
                    maxLength={10}
                    onChange={(e) => {
                      const numericValue = e.target.value.replace(/\D/g, ""); // Removes non-numeric characters
                      field.onChange(numericValue);
                    }}
                  />
                )}
              />
              {errors?.contact_no && (
                <sup className="text-danger">{errors?.contact_no?.message}</sup>
              )}
            </Form.Group>

            <Form.Group className="form-group">
              <Form.Control
                type="text"
                name="name"
                placeholder="Refer Code"
                {...register("refer_by", {
                  // required: "Refer Code required",
                })}
                className={classNames("", {
                  "is-invalid": errors?.refer_by,
                  "is-valid": getValues("refer_by"),
                })}
              />
              {errors?.refer_by && (
                <sup className="text-danger">{errors?.refer_by?.message}</sup>
              )}
            </Form.Group>


            <Form.Group className="form-group password_holder">
              <Form.Control
                type={showPassword ? "text" : "password"}
                placeholder="Password"
                name="password"
                {...register("password", {
                  required: "Password is required",
                  minLength: {
                    value: 8,
                    message: "Password must be at least 8 characters long",
                  },
                  pattern: {
                    value: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/,
                    message:
                      "Password must contain at least one uppercase letter, one lowercase letter, and one number",
                  },
                })}
                onChange={(e) => setPassword(e.target.value)}
              />
              {errors?.password && (
                <sup className="text-danger">{errors?.password?.message}</sup>
              )}
              <div className="eye-icc">
                <FontAwesomeIcon
                  icon={iconOne}
                  className="icon"
                  onClick={() => togglePasswordVisibility("password")}
                />
              </div>
            </Form.Group>

            <Form.Group className="form-group password_holder">
              <Form.Control
                type={showPasswordOne ? "text" : "password"}
                placeholder="Confrim Password"
                name="re_password"
                {...register("re_password", {
                  required: "Re-Enter Password  is required",
                })}
                onChange={(e) => setPasswordAgain(e.target.value)}
              />
              <div className="eye-icc">
                <FontAwesomeIcon
                  icon={iconTwo}
                  className="icon"
                  onClick={() => togglePasswordVisibility("reenterPassword")}
                />
              </div>
              {errors?.re_password && (
                <sup className="text-danger">
                  {errors?.re_password?.message}
                </sup>
              )}
              {password && (
                <PasswordChecklist
                  rules={[
                    "minLength",
                    "specialChar",
                    "number",
                    "capital",
                    "match",
                  ]}
                  minLength={8}
                  value={password}
                  valueAgain={passwordAgain}
                  onChange={(isValid) => {}}
                  style={{
                    fontSize: "10px",
                    padding: "4px",
                    margin: "0",
                  }}
                />
              )}
            </Form.Group>

            <div className="signup-btn text-center">
              <OrangeFilledRoundBtn
                btnText={"SignUp"}
                onClick={handleSubmit(onSubmit)}
                // onClick={() => {
                //   setShowSuccessModal(true);

                //   setTimeout(() => {
                //     navigate("/login");
                //   }, 5000);
                // }}
              />
            </div>
          </Form>

          <div className="btm-text">
            <p
              className="acc-creation"
              onClick={() => {
                navigate("/login");
              }}
            >
              Already have an account?
            </p>
            {/* <p className="social">or login with social accounts</p>
            <img
              src={process.env.PUBLIC_URL + "/assets/Images/Icons/google.png"}
              className="google-img"
              alt="google-img"
            /> */}
          </div>
          {/* <div className="home-link text-center mt-2">
            <Link to={"/"}>
              Back
              <span>
                <i class="fa-solid fa-angle-right arrow">‌</i>
              </span>
            </Link>
          </div> */}
        </div>
        <div className="img-holder">
          <Banner />
        </div>
      </Container>

      <BrownSuccessFullModal
        show={showSuccessModal}
        onHide={() => setShowSuccessModal(false)}
        successText="Sign-up successful!"
        successText2="We're thrilled to have you with us"
      />
    </section>
  );
}
